import { getReqAuth } from '../../api';

export const getAppLogs = (params, cb) =>
  getReqAuth('/webapi/institute/appLogs/list', {}, `?${new URLSearchParams(params).toString()}`, cb);

export const getAppLogDetail = (id, cb) =>
  getReqAuth('/webapi/institute/appLogs/detail/', {}, id, cb);

export const getAppLogStats = (cb) =>
  getReqAuth('/webapi/institute/appLogs/stats', {}, '', cb);
